export default "__VITE_ASSET__8IA1uOsm__"